import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { useApi, createAPIPOSTPayload } from "../auth";
import { backend_url } from "../constants";
import { useNavigate } from "react-router";

export default function Profile() {
  const [species, setSpecies] = useState("Rat");
  const [strain, setStrain] = useState("Sprague-Dawley");
  const [sex, setSex] = useState("F");
  const [adminRoute, setAdminRoute] = useState("Feed");
  const [doseUnit, setDoseUnit] = useState("ppm");
  const [durationLabel, setDurationLabel] = useState("chronic");
  const [submitted, setSubmitted] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [usedTokens, setUsedTokens] = useState(9999);
  const [totalTokens, setTotalTokens] = useState(0);
  const { apiFetch } = useApi();
  const navigate = useNavigate();
  const allowed_routes = [
    "Topical",
    "Feeding needles",
    "Subcutaneous",
    "Intraperitoneal",
    "Dermal",
    "Inhalation",
    "Capsule",
    "Intramuscular",
    "Drinking water",
    "Feed",
    "Intravenous",
    "Gavage",
  ];
  const strain_map = {
    Rat: ["Sprague-Dawley", "Fischer 344", "Wistar"],
    Mouse: ["CD-1", "B6C3F1", "Swiss"],
  };
  function setValsFromParameters(params) {
    setSpecies(params.species);
    setStrain(params.strain);
    setSex(params.sex);
    setAdminRoute(params.adminRoute);
    setDoseUnit(params.doseUnit);
    setDurationLabel(params.durationLabel);
  }
  useEffect(() => {
    apiFetch(backend_url + "/api/get-default-settings/")
      .then((res) => res.json())
      .then((data) => {
        setValsFromParameters(data);
      });
  }, []);
  useEffect(() => {
    apiFetch(backend_url + "/api/get-user-usage/")
      .then((res) => res.json())
      .then((data) => {
        setUsedTokens(data.used);
        setTotalTokens(data.total);
      });
  }, []);
  function setDefaultSettings() {
    const settings = {
      species: species,
      strain: strain,
      sex: sex,
      adminRoute: adminRoute,
      doseUnit: doseUnit,
      durationLabel: durationLabel,
    };
    const payload = createAPIPOSTPayload({ settings: settings });
    apiFetch(backend_url + "/api/set-default-settings/", payload).then((res) =>
      console.log("settings saved"),
    );
  }

  function changePassword() {
    const settings = {
      currentPassword: currentPassword,
      newPassword1: newPassword1,
      newPassword2: newPassword2
    };
    const payload = createAPIPOSTPayload(settings);
    apiFetch(backend_url + "/api/update-password/", payload).then((res) =>{
      if(res.status==200){
        console.log("password updated")
        navigate("/")
      }
      else{
        res.json().then(json=>console.log(json));
      }
    }
    );
  }


  return (
    <div className="profile-container">
      <Stack>
        <div className="usage-container">
          <h4>Your Usage</h4>
          <p>{usedTokens}/{totalTokens} tokens used this month</p>
          <i>Creating a data anlysis or running a user designed study design uses a token</i>
        </div>
        <div className="settings-container">
          <h4>Your Default Settings</h4>
          <Form>
            <Form.Group controlId="animalForm.SpeciesInput">
              <Form.Label>
                <b>Species</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={species}
                onChange={(e) => setSpecies(e.target.value)}
              >
                <option value="Rat">Rat</option>
                <option value="Mouse">Mouse</option>
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="animalForm.StrainInput">
              <Form.Label>
                <b>Strain</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={strain}
                onChange={(e) => setStrain(e.target.value)}
              >
                {strain_map[species]?.map((strain) => (
                  <option value={strain}>{strain}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="animalForm.SexInput">
              <Form.Label>
                <b>Sex</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={sex}
                onChange={(e) => setSex(e.target.value)}
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="B">Both</option>
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="adminForm.RouteInput">
              <Form.Label>
                <b>Administration Route</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={adminRoute}
                onChange={(e) => setAdminRoute(e.target.value)}
              >
                {allowed_routes.map((route) => (
                  <option value={route}>{route}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="unitForm.UnitInput">
              <Form.Label>
                <b>Dose Unit</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={doseUnit}
                onChange={(e) => setDoseUnit(e.target.value)}
              >
                <option value={"ppm"}>ppm</option>
                <option value={"mg/kg"}>mg/kg</option>
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="unitForm.UnitInput">
              <Form.Label>
                <b>Duration</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={durationLabel}
                onChange={(e) => setDurationLabel(e.target.value)}
              >
                <option value={"acute"}>acute</option>
                <option value={"subchronic"}>subchronic</option>
                <option value={"chronic"}>chronic</option>
              </Form.Select>
            </Form.Group>
          </Form>
          <Button
            className="dt-button"
            variant="primary"
            type="submit"
            style={{ width: "13rem", marginTop: "10px" }}
            onClick={(e) => {
              e.preventDefault();
              setDefaultSettings();
            }}
          >
            Update default settings
          </Button>
        </div>
        <div className="password-update-container">
          <h4>Update Your Password</h4>
          <Form>
            <Form.Group controlId="passwordForm.Current">
              <Form.Label>
                <b>Current Password</b>
              </Form.Label>
              <Form.Control
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="passwordForm.New">
              <Form.Label>
                <b>New Password</b>
              </Form.Label>
              <Form.Control
                type="password"
                value={newPassword1}
                onChange={(e) => setNewPassword1(e.target.value)}
              />
              <Form.Label>
                <b>New Password again</b>
              </Form.Label>
              <Form.Control
                type="password"
                value={newPassword2}
                onChange={(e) => setNewPassword2(e.target.value)}
              />
            </Form.Group>
          </Form>
          <Button
            className="dt-button"
            variant="primary"
            type="submit"
            style={{ width: "13rem", marginTop: "10px" }}
            onClick={(e) => {
              e.preventDefault();
              changePassword();
            }}
          >
            Update password
          </Button>
        </div>
      </Stack>
    </div>
  );
}
